import type { HTMLAttributes } from "react";

type BurgerMenuIconProps = HTMLAttributes<SVGElement>;

export default function BurgerMenuIcon({
  className,
  ...props
}: BurgerMenuIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16 12H3M20 6H3M20 18H3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
}
